<template>
  <vue-final-modal
    v-model="showModal"
    classes="modal-container"
    content-class="modal-content"
    name="newsletter"
    :click-to-close="false"
  >
    <slot></slot>
  </vue-final-modal>
</template>

<script>
import LiveForm from "nette-base-module/js/nette/LiveForm";

export default {
  data () {
    return { 
      showModal: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 3000);

    LiveForm.Nette.validators.AppCrmModuleModelValidators_isPhoneNumberControl = () => {
      return true;
    };
    import("libphonenumber-js").then(({ parsePhoneNumber }) => {
      LiveForm.Nette.validators.AppCrmModuleModelValidators_isPhoneNumberControl = (
        elem,
        arg,
        val
      ) => {
        if (!val) return false;
        if (new String(val).length <= 4) return false;

        try {
          const phoneNumber = parsePhoneNumber(val, "CZ");
          return phoneNumber.isValid();
        } catch (err) {
          return false;
        }
      };
    });
  },
}
</script>

<style lang="scss">
.vfm--inset {
  //top: 43px !important;
}
#bootstrap .modal-content,
.modal-content {
  width: 600px;
  max-height: 90vh;
}

#bootstrap .my-diary-login-form {
  margin-top: 50px;
  width: 100%;
}
</style>
